import {AttachmentFile} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit/src/common/utils/testingUtils'
import Close from '@mui/icons-material/Close'
import {Box, Grid, IconButton} from '@mui/material'
import {styled} from '@mui/system'
import React from 'react'

const AttachmentPreviewBox = styled(Box)(({theme}) => ({
  height: '100px',
  float: 'left',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  margin: theme.spacing(1)
}))

const CloseButton = styled(IconButton)(({theme}) => ({
  position: 'absolute',
  top: -8,
  right: -8,
  color: theme.palette.error.light,
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(3),
  width: '20px',
  height: '20px'
}))

export const AttachmentGallery: React.FC<{
  files: Array<AttachmentFile>
  setFiles: (attachments: AttachmentFile[]) => void
}> = ({files, setFiles}) => {
  const removeFile = (index: number) => {
    setFiles(files.filter((_, itemIndex) => itemIndex !== index))
  }

  return (
    <>
      <Grid>
        {files.map((file, index) => {
          return (
            <AttachmentPreviewBox
              key={`${file.name}-${index}`}
              {...dataTestId('attachment_preview')}
              border={1.5}
              sx={
                file.isImage
                  ? undefined
                  : {
                      borderColor: ({palette}) => palette.divider,
                      width: '125px',
                      borderRadus: 0.5
                    }
              }
            >
              <CloseButton onClick={() => removeFile(index)}>
                <Close />
              </CloseButton>
              {file.isImage ? (
                <Box component="img" src={file.preview} alt={file.name} sx={{maxHeight: '100px'}} />
              ) : (
                <Box
                  sx={{
                    width: '100px',
                    fontSize: 12,
                    lineHeight: '16px',
                    color: ({palette}) => palette.text.primary,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    margin: '0 auto'
                  }}
                >
                  {file.name}
                </Box>
              )}
            </AttachmentPreviewBox>
          )
        })}
      </Grid>
    </>
  )
}
